export const ModalMghrwc = {
  namespaced: true,
  state: {
    isOpen: false,
  },
  getters: {
    open: (state: any) => {
      return state.isOpen;
    },
  },
  mutations: {
    open: (state: any) => {
      state.isOpen = true;
    },
    close: (state: any) => {
      state.isOpen = false;
    },
  },
};
